import inProgressSvg from "../assets/image/InProgress.svg";
import inReviewSvg from "../assets/image/InReview.svg";
import blockedSvg from "../assets/image/blocked.svg";
import completedSvg from "../assets/image/completed.svg";
import newSvg from "../assets/image/new.svg";

export type Status = "New" | "In progress" | "In review" | "Resolved" | "Late";

export const statusIcon = (status: Status): JSX.Element => {
	switch (status?.toLowerCase()) {
		case "new":
			return <img className="no-visual-search" src={newSvg} />;
		case "in progress":
			return <img className="no-visual-search" src={inProgressSvg} />;
		case "in review":
			return <img className="no-visual-search" src={inReviewSvg} />;
		case "resolved":
			return <img className="no-visual-search" src={completedSvg} />;
		case "late":
			return <img className="no-visual-search" src={blockedSvg} />;
		default:
			return <img className="no-visual-search" src={newSvg} />;
	}
};

export const reportingStatusIcon = (status: string): JSX.Element => {
	switch (status) {
		case "draft":
			return <img className="no-visual-search" src={inProgressSvg} />;
		case "completed":
			return <img className="no-visual-search" src={completedSvg} />;
		default:
			return <img className="no-visual-search" src={newSvg} />;
	}
};

// Mark for excluded/disabled phase/task/deliverable
export const excludedMark = () => {
	return (
		<div style={{ display: "flex", alignItems: "center", opacity: "0.6" }}>
			(Excl.)
		</div>
	);
};
